import { z } from 'zod';
import { isValidEmail } from '../../../utils/Regex';

export const changeEmailRequestSchema = z.object({
  newEmail: z.string().trim().min(1, 'Email is Required').refine(isValidEmail, 'Invalid email address'),
});

export type ChangeEmailRequestValues = z.infer<typeof changeEmailRequestSchema>;

const otpCodeSchema = (label: string) =>
  z
    .string()
    .trim()
    .min(1, `${label} is required`)
    .regex(/^\d{6}$/, `Enter the 6-digit code sent to ${label === 'Old email code' ? 'your current' : 'your new'} email`);

export const changeEmailVerifySchema = z.object({
  oldEmailCode: otpCodeSchema('Old email code'),
  newEmailCode: otpCodeSchema('New email code'),
});

export type ChangeEmailVerifyValues = z.infer<typeof changeEmailVerifySchema>;
